import React, { useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BasicHeader from '../../CommonComponents/Header/index';
import styles from '../css/index.module.css';
import Pageheader from '../../../utils/headerHelment';
import { AiFillCloseCircle, AiOutlineLoading3Quarters } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { format, addYears } from 'date-fns';
import { updateProject, AddNda } from '../../../redux/projectDataSlice';
import { isValidNdaExtensionToUpload } from '../../../utils/commonUtils';
import DatePicker from '../../../utils/DatePicker';
import { Delete20Regular } from '@fluentui/react-icons';

function UploadNda({ onlyNda }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation(); // Get the location object using the useLocation hook

    const { selectedProject, ndaButtonLoading } = useSelector(state => state.projectData);
    const { user } = useSelector(state => state.user);
    const [validityDate, setValidityDate] = useState(addYears(new Date(), 3));
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [isDragging, setIsDragging] = React.useState(false);
    const fileInputRef = React.useRef();

    const handleDate = date => {
        setValidityDate(date);
    };

    const handleDivClick = () => {
        fileInputRef.current.click();
    };

    const processFile = file => {
        if (file && isValidNdaExtensionToUpload(file.name.split('.').pop().toLowerCase())) {
            setSelectedFile(file);
        }
    };

    const handleFileChange = e => {
        const selectedFiles = Array.from(e.target.files);
        if (selectedFiles?.length > 0) {
            processFile(selectedFiles[0]);
        }
    };

    const handleDragEnter = e => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };

    const handleDragLeave = e => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDragOver = e => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = e => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        const files = Array.from(e.dataTransfer.files);
        if (files?.length > 0) {
            processFile(files[0]);
        }
    };

    const handleSubmit = async e => {
        e.preventDefault();
        const FiletoUpload = new FormData();
        selectedFile && FiletoUpload.append('document', selectedFile);
        validityDate !== '' && FiletoUpload.append('expiry', format(validityDate, 'yyyy-MM-dd'));
        const res = await dispatch(AddNda(FiletoUpload));
        console.log(res);
        if (res?.type !== 'POST_NDA_DOC/rejected') {
            dispatch(
                updateProject({
                    ...selectedProject,
                    vdr: {
                        ...selectedProject?.vdr,
                        nda: res?.payload?.data,
                    },
                }),
            );
            handleNavigateNext();
        }
    };
    const handleNavigateNext = () => {
        const isProjectAdmin = selectedProject?.vdr?.vdr_admin === user?.id || selectedProject?.project_admins?.some(admin => admin.user_id === user?.id);
        console.log(isProjectAdmin);
        navigate(user?.has_diligence_tools ? '/overview' : '/dataroom');
        // if (isProjectAdmin) {
        // }
        //  else navigate('/tc');
    };
    const handleClearFile = () => {
        setSelectedFile(null);
    };
    return (
        <>
            <BasicHeader />
            <div className="bg-light">
                <Pageheader title="LENS - Upload NDA" />
                <div className="container-fluid">
                    <div className={` ${styles.viewHeight}`}>
                        <div className={`${styles.content} `}>
                            <div className="row">
                                <div className="col-sm-12 col-md-4">
                                    <div className="d-flex justify-content-between align-items-center mb-5">
                                        <h2 className={styles.headingText + ' mb-1'}>{selectedProject?.project_name} NDA</h2>
                                        <button onClick={handleNavigateNext} className={styles.borderdButton}>
                                            Skip
                                        </button>
                                    </div>
                                    <form className="mb-5">
                                        <div className="row">
                                            {selectedFile ? (
                                                <div className="d-flex justify-content-between align-items-center mb-4 mt-4">
                                                    <p>{selectedFile?.name}</p>
                                                    <Delete20Regular role="button" onClick={handleClearFile} />
                                                </div>
                                            ) : (
                                                <div className="row pe-0 mb-3">
                                                    <div className="col-12 pe-0">
                                                        <label htmlFor className="form-label mb-1 smallFont">
                                                            Upload NDA
                                                        </label>
                                                        <div
                                                            id="uploadDiv"
                                                            className={`${styles.uploadBox} ${isDragging ? styles.dragging : ''}`}
                                                            onClick={handleDivClick}
                                                            onDragEnter={handleDragEnter}
                                                            onDragOver={handleDragOver}
                                                            onDragLeave={handleDragLeave}
                                                            onDrop={handleDrop}>
                                                            <span className={styles.uploadTextDragDrop}>
                                                                Drag & drop NDA file or
                                                                <br />
                                                                click to upload
                                                                <br />
                                                                <br />
                                                                <small>(PDF, DOC, DOCX)</small>
                                                            </span>
                                                            <input
                                                                multiple={false}
                                                                type="file"
                                                                accept=".pdf,.doc,.docx"
                                                                ref={fileInputRef}
                                                                style={{ display: 'none' }}
                                                                onChange={handleFileChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="row">
                                            <div className=" col-sm-12 col-md-6">
                                                <div className="mb-4 customDp">
                                                    <label htmlFor className="form-label mb-1 smallFont">
                                                        Valid until
                                                    </label>
                                                    {/* <CustomDatepicker dateValue={validityDate} setDatedateValue={handleDate} /> */}
                                                    <DatePicker value={validityDate} onChange={e => setValidityDate(e)} />
                                                </div>{' '}
                                            </div>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center ">
                                            <button onClick={handleSubmit} type="submit" className="btn btn-primary smallButton ">
                                                Save {ndaButtonLoading && <AiOutlineLoading3Quarters className="rotateLoader" />}
                                            </button>
                                            <button className={styles.borderdButton} onClick={() => navigate(location?.state?.newNda ? '/AddProjectDetails' : '/dataroom')}>
                                                Back
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UploadNda;
